import { HTTP } from '../http.js'

export default {
    getAll() {
        return HTTP.get('/tradera_stores');
    },

    get(id) {
        return HTTP.get(`/tradera_stores/${id}`);
    }
};
